import React from "react";
import { formatNoteDate } from "../../utils/dateUtils";

function ViewNoteModal({ show, note, onClose, onDelete }) {
  if (!show || !note) return null;
  
  // ✅ Wrap formatNoteDate(note.created) in a safe check or fallback if note.created is missing
  const safeNoteText = note.text || 'Empty note';
  const safeCreatedDate = note.created 
    ? formatNoteDate(note.created) 
    : 'No date available';
  
  // ✅ Confirm note.id exists before calling onDelete(note.id)
  const handleDelete = () => {
    if (note.id) {
      onDelete(note.id);
      onClose();
    } else {
      console.warn('Cannot delete note: no ID provided');
      onClose();
    }
  };
  
  return (
    <div className="modal-overlay">
      <div className="modal-content neutral">
        <button className="close-button" onClick={onClose}>✕</button>
        <h3 style={{ marginBottom: "1.2rem" }}>📝 Note</h3>
        <div style={{ fontSize: "1.1rem", marginBottom: "1rem" }}>{safeNoteText}</div>
        <div style={{ color: "#888", fontSize: "0.95rem", marginBottom: "1.5rem" }}>
          Added: {safeCreatedDate}
        </div>
        <button
          onClick={handleDelete}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#E96A6A",
            border: "none",
            borderRadius: "6px",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Delete Note
        </button>
      </div>
    </div>
  );
}

export default ViewNoteModal;